<p-toast class="toast-content" position="top-center"></p-toast>
<router-outlet></router-outlet>
<app-confirmation-modal></app-confirmation-modal>
<ngx-spinner [zIndex]="999999"
  bdColor="rgba(255,255,255, 0.8)"
  template="<img src='{{imageUrl}}loader.svg' />"
>
<p class="loadertext"> Please wait... </p>
</ngx-spinner>
<app-session-expiration-alert></app-session-expiration-alert>